(function() {
  const BOX_VARIANT_ID = 55784516190548;
  const EXTRA_VARIANT_ID = 55645499097428;

  async function syncCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const hasBox = cart.items.some(i => i.variant_id === BOX_VARIANT_ID);
    const extraItem = cart.items.find(i => i.variant_id === EXTRA_VARIANT_ID);
    console.log('SYNC - BOX:', hasBox, '| EXTRA:', !!extraItem);
    if (!hasBox && extraItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: extraItem.key, quantity: 0 })
      });
      window.location.reload();
    }
  }

  syncCart();
  setInterval(syncCart, 3000);
})();